var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewEvolution',{attrs:{"title":"EVOLUÇÃO TERAPEUTA OCUPACIONAL","type":"TERAPEUTA_OCUPACIONAL","resident_id":_vm.resident_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }